<template>
    <section v-if="hasPermissions(['Options-Floor-Types Read','Options-Floor-Types Write', 'Options-Floor-Types Floor-Types-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all the Floor Types. To add a new floor type, click Add Floor Type. Enter a name and check the Project Tasks you want to associate with this floor type. Click Save.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="floor_types.length && hasPermissions(['Options-Floor-Types Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'floor_types_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Options-Floor-Types Floor-Types-Upload'])"
                />
                <UploadOptions
                    v-if="hasPermissions(['Options-Floor-Types Upload-Tasks'])"
                    :ref="'file_excel_tasks'"
                    :empty_format_data="empty_format_data_tasks"
                    :excel_file_headers="excel_file_headers_tasks"
                    :file_name="'floor_tasks_upload_template_file'"
                    :btn_label="'Tasks Upload options'"
                    id="file_excel_input_tasks"
                    @data="uploadTasks($event)"
                />
                <button v-if="hasPermissions(['Options-Floor-Types Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Options-Floor-Types Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="floor_types.length && hasPermissions(['Options-Floor-Types Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="floor_types"
                                :search="search"
                                :checkable="true"
                                link="#"
                                :historiable="false"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <DeleteValidationsModal 
            :validate_data="delete_validations"
            :breadcrumb="breadcrumb"
            ref="DeleteValidationsModal"
            @replacingAssociates="replacingAssociates($event)"
        />

        <FormModal 
            :title="'Floor Type Valid Project Tasks'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :project_tasks="project_tasks"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Floor Type Valid Project Tasks'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :project_tasks="project_tasks"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        />

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'
import DeleteValidationsModal   from './DeleteValidationsModal';

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'FloorTypes',

    components: {
        Breadcrumb,
        WaitingModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        DeleteValidationsModal
    },

    data() {
        return {
            notyf,
            axios,
            user:                   this.get_user(),
            title_page:             'Floor Types',
            rest_api:               `floor_types`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Floor Type',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            floor_types:            [],
            project_tasks:          [],
            array_options:          {},
            select_ids:             [],
            excel_file_headers:         Resources.excel_file_headers,
            empty_format_data:          Resources.empty_format_data,
            excel_file_headers_tasks:   Resources.excel_file_headers_tasks,
            empty_format_data_tasks:    Resources.empty_format_data_tasks,
            summary:                [],
            excel_data:             [],
            delete_validations:     [],
            name_file_summary: ''
        }
    },

    methods: {

        unshift_object(new_object)
        {
            this.floor_types.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.floor_types.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            this.project_tasks.map(item => item.checked = false)
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.floor_types[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = { ...this.floor_types[index] }
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.floor_types = data.floor_types
            this.project_tasks = data.project_tasks
        },

        trashing(index)
        {
            this.floor_types.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.floor_types.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
                massive:    true,
            }

            let sendingMassive = await this.massive_delete(json_request, null, true)

            if(sendingMassive)
            {
                if(sendingMassive.data)
                {
                    this.delete_validations = sendingMassive.data.validations

                    if(this.delete_validations.length)
                    {
                        window.$('#delete-validations').modal('show')
                    }

                    if(sendingMassive.data.floors_deleted_id)
                    {
                        sendingMassive.data.floors_deleted_id.forEach( item =>
                        {
                            const index = this.floor_types.findIndex(value => value.decrypted_id == item)
                            if(index > -1)
                            {
                                this.floor_types.splice(index, 1)
                            }
                        })
                    }
                }

                this.select_ids = []
            }
        },

        async upload(data)
        {
            this.name_file_summary = 'floor_types_failed_template_file'
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}
                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { floor_types: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                
                for (const floor_type of response.data.floor_types) {
                    this.unshift_object(floor_type);
                }
            }
            else
            {
                this.error_handling(response)
            }
            
            this.$refs.file_excel.clear_data()
        },

        async uploadTasks(data)
        {
            this.name_file_summary = 'floor_tasks_failed_template_file'

            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive_tasks`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers_tasks
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                await this.api_request()

            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel_tasks.clear_data()
        },
    },

    async mounted() {
        if(this.hasPermissions(['Options-Floor-Types Read','Options-Floor-Types Write', 'Options-Floor-Types Floor-Types-Upload']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.floor_types.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },

}
</script>
